export default "__VITE_ASSET__DET46Blp__"